// import $ from 'jquery';
import React from 'react'
import Field from './Field'
// import PropTypes from 'prop-types';

class FieldCheckbox extends Field {
  constructor(props) {
    super(props)
  }
  // format(value) {
  // }
  validate() {
    const { checked, required } = this.props

    let testChecked = true
    if (required && !checked) {
      testChecked = false
    }

    return super.validate() && testChecked
  }
  handleClasses() {
    let fieldClassName = 'field--checkbox'
    const overrideDefaultClassName =
      typeof this.props.overrideDefaultClassName != 'undefined' ? this.props.overrideDefaultClassName : false

    if (overrideDefaultClassName != '') {
      fieldClassName = overrideDefaultClassName
    }

    return super.handleClasses().concat(' ' + fieldClassName)
  }
  render() {
    const { animatedLabel, checked } = this.props

    return (
      <label className={this.handleClasses()} data-label={animatedLabel} ref={(r) => (this.field = r)}>
        {super.renderAutoresize()}
        <input
          className="field__input"
          ref={(r) => (this.input = r)}
          {...super.generateProps()}
          type="checkbox"
          checked={checked}
        />
        {super.renderValue()}
        {super.renderError()}
      </label>
    )
  }
}

export default FieldCheckbox
